import Vue from 'vue'
import { decode, parsePath, withoutBase, withoutTrailingSlash, normalizeURL } from 'ufo'

import { getMatchedComponentsInstances, getChildrenComponentInstancesUsingFetch, promisify, globalHandleError, urlJoin, sanitizeComponent } from './utils'
import NuxtError from '../src/layouts/error.vue'
import NuxtLoading from './components/nuxt-loading.vue'

import '../src/assets/styles/style.css'

import '../src/assets/styles/buttons.css'

const _77180f1e = () => import('../src/layouts/blank.vue'  /* webpackChunkName: "layouts/blank" */).then(m => sanitizeComponent(m.default || m))
const _d0ef6c0e = () => import('../src/layouts/ConverterTemplates/GroupTemplate.vue'  /* webpackChunkName: "layouts/ConverterTemplates/GroupTemplate" */).then(m => sanitizeComponent(m.default || m))
const _4d80794c = () => import('../src/layouts/ConverterTemplates/IndexTemplate.vue'  /* webpackChunkName: "layouts/ConverterTemplates/IndexTemplate" */).then(m => sanitizeComponent(m.default || m))
const _74a5e6f2 = () => import('../src/layouts/ConverterTemplates/PreviewLayout.vue'  /* webpackChunkName: "layouts/ConverterTemplates/PreviewLayout" */).then(m => sanitizeComponent(m.default || m))
const _3e0c337c = () => import('../src/layouts/ConverterTemplates/PreviewTemplate.vue'  /* webpackChunkName: "layouts/ConverterTemplates/PreviewTemplate" */).then(m => sanitizeComponent(m.default || m))
const _6c97e024 = () => import('../src/layouts/ConverterTemplates/SecondaryTemplate.vue'  /* webpackChunkName: "layouts/ConverterTemplates/SecondaryTemplate" */).then(m => sanitizeComponent(m.default || m))
const _5313d1fc = () => import('../src/layouts/ConverterTemplates/SingleTemplate.vue'  /* webpackChunkName: "layouts/ConverterTemplates/SingleTemplate" */).then(m => sanitizeComponent(m.default || m))
const _13a5b452 = () => import('../src/layouts/ConverterTemplates/ToolTemplate.vue'  /* webpackChunkName: "layouts/ConverterTemplates/ToolTemplate" */).then(m => sanitizeComponent(m.default || m))
const _60a9b38e = () => import('../src/layouts/ConverterTemplates/UnitIndex.vue'  /* webpackChunkName: "layouts/ConverterTemplates/UnitIndex" */).then(m => sanitizeComponent(m.default || m))
const _a67ca1b4 = () => import('../src/layouts/ConverterTemplates/UnitSingleIndex.vue'  /* webpackChunkName: "layouts/ConverterTemplates/UnitSingleIndex" */).then(m => sanitizeComponent(m.default || m))
const _81d5e2c6 = () => import('../src/layouts/ConverterTemplates/UnitTypesIndex.vue'  /* webpackChunkName: "layouts/ConverterTemplates/UnitTypesIndex" */).then(m => sanitizeComponent(m.default || m))
const _5fa3735e = () => import('../src/layouts/dashboard.vue'  /* webpackChunkName: "layouts/dashboard" */).then(m => sanitizeComponent(m.default || m))
const _6f6c098b = () => import('../src/layouts/default.vue'  /* webpackChunkName: "layouts/default" */).then(m => sanitizeComponent(m.default || m))
const _97f81de8 = () => import('../src/layouts/full-blank.vue'  /* webpackChunkName: "layouts/full-blank" */).then(m => sanitizeComponent(m.default || m))
const _565a2668 = () => import('../src/layouts/grid/flexible-grid-card.vue'  /* webpackChunkName: "layouts/grid/flexible-grid-card" */).then(m => sanitizeComponent(m.default || m))
const _90785116 = () => import('../src/layouts/grid/flexible-grid.vue'  /* webpackChunkName: "layouts/grid/flexible-grid" */).then(m => sanitizeComponent(m.default || m))
const _6f54e3a4 = () => import('../src/layouts/partials/account/footer.vue'  /* webpackChunkName: "layouts/partials/account/footer" */).then(m => sanitizeComponent(m.default || m))
const _60fca9e0 = () => import('../src/layouts/partials/account/payment/card-edit-dialog.vue'  /* webpackChunkName: "layouts/partials/account/payment/card-edit-dialog" */).then(m => sanitizeComponent(m.default || m))
const _6c19dcd8 = () => import('../src/layouts/partials/account/payment/card-editor.vue'  /* webpackChunkName: "layouts/partials/account/payment/card-editor" */).then(m => sanitizeComponent(m.default || m))
const _4e264642 = () => import('../src/layouts/partials/account/payment/credit-cards-table.vue'  /* webpackChunkName: "layouts/partials/account/payment/credit-cards-table" */).then(m => sanitizeComponent(m.default || m))
const _6c4e1d02 = () => import('../src/layouts/partials/account/payment/stripe.vue'  /* webpackChunkName: "layouts/partials/account/payment/stripe" */).then(m => sanitizeComponent(m.default || m))
const _352044d2 = () => import('../src/layouts/partials/account/report/combined.vue'  /* webpackChunkName: "layouts/partials/account/report/combined" */).then(m => sanitizeComponent(m.default || m))
const _465ee67d = () => import('../src/layouts/partials/account/team/change-user-permission.vue'  /* webpackChunkName: "layouts/partials/account/team/change-user-permission" */).then(m => sanitizeComponent(m.default || m))
const _698cf2a5 = () => import('../src/layouts/partials/account/team/create-team.vue'  /* webpackChunkName: "layouts/partials/account/team/create-team" */).then(m => sanitizeComponent(m.default || m))
const _1c1804f1 = () => import('../src/layouts/partials/account/team/delete-team-member.vue'  /* webpackChunkName: "layouts/partials/account/team/delete-team-member" */).then(m => sanitizeComponent(m.default || m))
const _441aa356 = () => import('../src/layouts/partials/account/team/delete-team.vue'  /* webpackChunkName: "layouts/partials/account/team/delete-team" */).then(m => sanitizeComponent(m.default || m))
const _10b2b817 = () => import('../src/layouts/partials/account/team/edit-team.vue'  /* webpackChunkName: "layouts/partials/account/team/edit-team" */).then(m => sanitizeComponent(m.default || m))
const _52b304de = () => import('../src/layouts/partials/account/team/invite-members.vue'  /* webpackChunkName: "layouts/partials/account/team/invite-members" */).then(m => sanitizeComponent(m.default || m))
const _6278bcf7 = () => import('../src/layouts/partials/account/team/join-team.vue'  /* webpackChunkName: "layouts/partials/account/team/join-team" */).then(m => sanitizeComponent(m.default || m))
const _7794818c = () => import('../src/layouts/partials/account/team/user-leave-team.vue'  /* webpackChunkName: "layouts/partials/account/team/user-leave-team" */).then(m => sanitizeComponent(m.default || m))
const _49a5ad07 = () => import('../src/layouts/partials/account/webhook/copy-secret.vue'  /* webpackChunkName: "layouts/partials/account/webhook/copy-secret" */).then(m => sanitizeComponent(m.default || m))
const _95812eaa = () => import('../src/layouts/partials/account/webhook/delete-api-key.vue'  /* webpackChunkName: "layouts/partials/account/webhook/delete-api-key" */).then(m => sanitizeComponent(m.default || m))
const _2dfb6ef6 = () => import('../src/layouts/partials/account/webhook/delete-webhook.vue'  /* webpackChunkName: "layouts/partials/account/webhook/delete-webhook" */).then(m => sanitizeComponent(m.default || m))
const _7b25c93b = () => import('../src/layouts/partials/account/webhook/webhook-form.vue'  /* webpackChunkName: "layouts/partials/account/webhook/webhook-form" */).then(m => sanitizeComponent(m.default || m))
const _456def9d = () => import('../src/layouts/partials/ads/AdInPage.vue'  /* webpackChunkName: "layouts/partials/ads/AdInPage" */).then(m => sanitizeComponent(m.default || m))
const _078185be = () => import('../src/layouts/partials/ads/AdsSide.vue'  /* webpackChunkName: "layouts/partials/ads/AdsSide" */).then(m => sanitizeComponent(m.default || m))
const _73e9f0aa = () => import('../src/layouts/partials/ads/AdsSideLayout.vue'  /* webpackChunkName: "layouts/partials/ads/AdsSideLayout" */).then(m => sanitizeComponent(m.default || m))
const _0a6edccc = () => import('../src/layouts/partials/ads/BottomFloatingAd.vue'  /* webpackChunkName: "layouts/partials/ads/BottomFloatingAd" */).then(m => sanitizeComponent(m.default || m))
const _607ce830 = () => import('../src/layouts/partials/footer/Footer.vue'  /* webpackChunkName: "layouts/partials/footer/Footer" */).then(m => sanitizeComponent(m.default || m))
const _b674f79a = () => import('../src/layouts/partials/footer/FooterBottom.vue'  /* webpackChunkName: "layouts/partials/footer/FooterBottom" */).then(m => sanitizeComponent(m.default || m))
const _9c2bae9a = () => import('../src/layouts/partials/footer/FooterLinkLists.vue'  /* webpackChunkName: "layouts/partials/footer/FooterLinkLists" */).then(m => sanitizeComponent(m.default || m))
const _56ac9fc8 = () => import('../src/layouts/partials/footer/FooterNavigation.vue'  /* webpackChunkName: "layouts/partials/footer/FooterNavigation" */).then(m => sanitizeComponent(m.default || m))
const _76402d9e = () => import('../src/layouts/partials/footer/FooterSocials.vue'  /* webpackChunkName: "layouts/partials/footer/FooterSocials" */).then(m => sanitizeComponent(m.default || m))
const _01864348 = () => import('../src/layouts/partials/navigation/Navigation.vue'  /* webpackChunkName: "layouts/partials/navigation/Navigation" */).then(m => sanitizeComponent(m.default || m))
const _fa7a9de0 = () => import('../src/layouts/partials/navigation/NavigationAuth.vue'  /* webpackChunkName: "layouts/partials/navigation/NavigationAuth" */).then(m => sanitizeComponent(m.default || m))
const _7d2c5ff6 = () => import('../src/layouts/partials/navigation/NavigationConverterList.vue'  /* webpackChunkName: "layouts/partials/navigation/NavigationConverterList" */).then(m => sanitizeComponent(m.default || m))
const _3c72db4e = () => import('../src/layouts/partials/navigation/NavigationDrawer.vue'  /* webpackChunkName: "layouts/partials/navigation/NavigationDrawer" */).then(m => sanitizeComponent(m.default || m))
const _53ae2d5e = () => import('../src/layouts/partials/navigation/NavigationLinks.vue'  /* webpackChunkName: "layouts/partials/navigation/NavigationLinks" */).then(m => sanitizeComponent(m.default || m))
const _4f698c36 = () => import('../src/layouts/partials/navigation/NavigationLinksResponsive.vue'  /* webpackChunkName: "layouts/partials/navigation/NavigationLinksResponsive" */).then(m => sanitizeComponent(m.default || m))
const _5e35cb1c = () => import('../src/layouts/partials/navigation/NavigationResponsive.vue'  /* webpackChunkName: "layouts/partials/navigation/NavigationResponsive" */).then(m => sanitizeComponent(m.default || m))
const _fdee3c84 = () => import('../src/layouts/partials/navigation/NavigationToolList.vue'  /* webpackChunkName: "layouts/partials/navigation/NavigationToolList" */).then(m => sanitizeComponent(m.default || m))
const _6750eaec = () => import('../src/layouts/partials/navigation/NavigationWeb.vue'  /* webpackChunkName: "layouts/partials/navigation/NavigationWeb" */).then(m => sanitizeComponent(m.default || m))
const _179155b8 = () => import('../src/layouts/partials/navigation/UserFiles.vue'  /* webpackChunkName: "layouts/partials/navigation/UserFiles" */).then(m => sanitizeComponent(m.default || m))
const _7883f2e6 = () => import('../src/layouts/partials/page/ConversionGuide.vue'  /* webpackChunkName: "layouts/partials/page/ConversionGuide" */).then(m => sanitizeComponent(m.default || m))
const _777b30ce = () => import('../src/layouts/partials/page/TryFree.vue'  /* webpackChunkName: "layouts/partials/page/TryFree" */).then(m => sanitizeComponent(m.default || m))
const _5cadfe66 = () => import('../src/layouts/partials/payment/CardEditor.vue'  /* webpackChunkName: "layouts/partials/payment/CardEditor" */).then(m => sanitizeComponent(m.default || m))
const _563bc1ba = () => import('../src/layouts/partials/payment/PaymentForm.vue'  /* webpackChunkName: "layouts/partials/payment/PaymentForm" */).then(m => sanitizeComponent(m.default || m))
const _3a3409ba = () => import('../src/layouts/partials/payment/Paypal.vue'  /* webpackChunkName: "layouts/partials/payment/Paypal" */).then(m => sanitizeComponent(m.default || m))
const _2de60706 = () => import('../src/layouts/partials/payment/Stripe.vue'  /* webpackChunkName: "layouts/partials/payment/Stripe" */).then(m => sanitizeComponent(m.default || m))
const _b16da23c = () => import('../src/layouts/partials/pricing/Plan/ConversionMinutesHintDialog.vue'  /* webpackChunkName: "layouts/partials/pricing/Plan/ConversionMinutesHintDialog" */).then(m => sanitizeComponent(m.default || m))
const _3cdb2410 = () => import('../src/layouts/partials/pricing/Plan/CustomPlanDialog.vue'  /* webpackChunkName: "layouts/partials/pricing/Plan/CustomPlanDialog" */).then(m => sanitizeComponent(m.default || m))
const _fdb39648 = () => import('../src/layouts/partials/pricing/Plan/index.vue'  /* webpackChunkName: "layouts/partials/pricing/Plan/index" */).then(m => sanitizeComponent(m.default || m))
const _565370ff = () => import('../src/layouts/partials/pricing/Plan/MoneyBackGuaranteeDialog.vue'  /* webpackChunkName: "layouts/partials/pricing/Plan/MoneyBackGuaranteeDialog" */).then(m => sanitizeComponent(m.default || m))
const _fdb1befe = () => import('../src/layouts/partials/pricing/Plan/Partners.vue'  /* webpackChunkName: "layouts/partials/pricing/Plan/Partners" */).then(m => sanitizeComponent(m.default || m))
const _7149f400 = () => import('../src/layouts/partials/pricing/Plan/PlanSwitcher.vue'  /* webpackChunkName: "layouts/partials/pricing/Plan/PlanSwitcher" */).then(m => sanitizeComponent(m.default || m))
const _97220d04 = () => import('../src/layouts/partials/pricing/Plan/single.vue'  /* webpackChunkName: "layouts/partials/pricing/Plan/single" */).then(m => sanitizeComponent(m.default || m))
const _b9817852 = () => import('../src/layouts/partials/pricing/PricingSlider.vue'  /* webpackChunkName: "layouts/partials/pricing/PricingSlider" */).then(m => sanitizeComponent(m.default || m))
const _7e7b311a = () => import('../src/layouts/partials/sections/SectionFullwidthBackground.vue'  /* webpackChunkName: "layouts/partials/sections/SectionFullwidthBackground" */).then(m => sanitizeComponent(m.default || m))
const _4fae9af9 = () => import('../src/layouts/partials/sections/SidePane.vue'  /* webpackChunkName: "layouts/partials/sections/SidePane" */).then(m => sanitizeComponent(m.default || m))
const _807147d4 = () => import('../src/layouts/partials/time/TimeChart.vue'  /* webpackChunkName: "layouts/partials/time/TimeChart" */).then(m => sanitizeComponent(m.default || m))
const _22fe31d8 = () => import('../src/layouts/partials/time/TimeConverter.vue'  /* webpackChunkName: "layouts/partials/time/TimeConverter" */).then(m => sanitizeComponent(m.default || m))
const _47c1853c = () => import('../src/layouts/partials/unit/Formula.vue'  /* webpackChunkName: "layouts/partials/unit/Formula" */).then(m => sanitizeComponent(m.default || m))
const _0f2e87a0 = () => import('../src/layouts/partials/unit/UnitConversionTable.vue'  /* webpackChunkName: "layouts/partials/unit/UnitConversionTable" */).then(m => sanitizeComponent(m.default || m))
const _4a2b4378 = () => import('../src/layouts/partials/unit/UnitConverter.vue'  /* webpackChunkName: "layouts/partials/unit/UnitConverter" */).then(m => sanitizeComponent(m.default || m))
const _7286be58 = () => import('../src/layouts/partials/unit/UnitGuide.vue'  /* webpackChunkName: "layouts/partials/unit/UnitGuide" */).then(m => sanitizeComponent(m.default || m))
const _720494de = () => import('../src/layouts/partials/unit/UnitLinks.vue'  /* webpackChunkName: "layouts/partials/unit/UnitLinks" */).then(m => sanitizeComponent(m.default || m))

let resolvedLayouts = {}
const layouts = { "_blank": _77180f1e,"_ConverterTemplates/GroupTemplate": _d0ef6c0e,"_ConverterTemplates/IndexTemplate": _4d80794c,"_ConverterTemplates/PreviewLayout": _74a5e6f2,"_ConverterTemplates/PreviewTemplate": _3e0c337c,"_ConverterTemplates/SecondaryTemplate": _6c97e024,"_ConverterTemplates/SingleTemplate": _5313d1fc,"_ConverterTemplates/ToolTemplate": _13a5b452,"_ConverterTemplates/UnitIndex": _60a9b38e,"_ConverterTemplates/UnitSingleIndex": _a67ca1b4,"_ConverterTemplates/UnitTypesIndex": _81d5e2c6,"_dashboard": _5fa3735e,"_default": _6f6c098b,"_full-blank": _97f81de8,"_grid/flexible-grid-card": _565a2668,"_grid/flexible-grid": _90785116,"_partials/account/footer": _6f54e3a4,"_partials/account/payment/card-edit-dialog": _60fca9e0,"_partials/account/payment/card-editor": _6c19dcd8,"_partials/account/payment/credit-cards-table": _4e264642,"_partials/account/payment/stripe": _6c4e1d02,"_partials/account/report/combined": _352044d2,"_partials/account/team/change-user-permission": _465ee67d,"_partials/account/team/create-team": _698cf2a5,"_partials/account/team/delete-team-member": _1c1804f1,"_partials/account/team/delete-team": _441aa356,"_partials/account/team/edit-team": _10b2b817,"_partials/account/team/invite-members": _52b304de,"_partials/account/team/join-team": _6278bcf7,"_partials/account/team/user-leave-team": _7794818c,"_partials/account/webhook/copy-secret": _49a5ad07,"_partials/account/webhook/delete-api-key": _95812eaa,"_partials/account/webhook/delete-webhook": _2dfb6ef6,"_partials/account/webhook/webhook-form": _7b25c93b,"_partials/ads/AdInPage": _456def9d,"_partials/ads/AdsSide": _078185be,"_partials/ads/AdsSideLayout": _73e9f0aa,"_partials/ads/BottomFloatingAd": _0a6edccc,"_partials/footer/Footer": _607ce830,"_partials/footer/FooterBottom": _b674f79a,"_partials/footer/FooterLinkLists": _9c2bae9a,"_partials/footer/FooterNavigation": _56ac9fc8,"_partials/footer/FooterSocials": _76402d9e,"_partials/navigation/Navigation": _01864348,"_partials/navigation/NavigationAuth": _fa7a9de0,"_partials/navigation/NavigationConverterList": _7d2c5ff6,"_partials/navigation/NavigationDrawer": _3c72db4e,"_partials/navigation/NavigationLinks": _53ae2d5e,"_partials/navigation/NavigationLinksResponsive": _4f698c36,"_partials/navigation/NavigationResponsive": _5e35cb1c,"_partials/navigation/NavigationToolList": _fdee3c84,"_partials/navigation/NavigationWeb": _6750eaec,"_partials/navigation/UserFiles": _179155b8,"_partials/page/ConversionGuide": _7883f2e6,"_partials/page/TryFree": _777b30ce,"_partials/payment/CardEditor": _5cadfe66,"_partials/payment/PaymentForm": _563bc1ba,"_partials/payment/Paypal": _3a3409ba,"_partials/payment/Stripe": _2de60706,"_partials/pricing/Plan/ConversionMinutesHintDialog": _b16da23c,"_partials/pricing/Plan/CustomPlanDialog": _3cdb2410,"_partials/pricing/Plan/index": _fdb39648,"_partials/pricing/Plan/MoneyBackGuaranteeDialog": _565370ff,"_partials/pricing/Plan/Partners": _fdb1befe,"_partials/pricing/Plan/PlanSwitcher": _7149f400,"_partials/pricing/Plan/single": _97220d04,"_partials/pricing/PricingSlider": _b9817852,"_partials/sections/SectionFullwidthBackground": _7e7b311a,"_partials/sections/SidePane": _4fae9af9,"_partials/time/TimeChart": _807147d4,"_partials/time/TimeConverter": _22fe31d8,"_partials/unit/Formula": _47c1853c,"_partials/unit/UnitConversionTable": _0f2e87a0,"_partials/unit/UnitConverter": _4a2b4378,"_partials/unit/UnitGuide": _7286be58,"_partials/unit/UnitLinks": _720494de }

export default {
  render (h, props) {
    const loadingEl = h('NuxtLoading', { ref: 'loading' })

    const layoutEl = h(this.layout || 'nuxt')
    const templateEl = h('div', {
      domProps: {
        id: '__layout'
      },
      key: this.layoutName
    }, [layoutEl])

    const transitionEl = h('transition', {
      props: {
        name: 'layout',
        mode: 'out-in'
      },
      on: {
        beforeEnter (el) {
          // Ensure to trigger scroll event after calling scrollBehavior
          window.$nuxt.$nextTick(() => {
            window.$nuxt.$emit('triggerScroll')
          })
        }
      }
    }, [templateEl])

    return h('div', {
      domProps: {
        id: '__nuxt'
      }
    }, [
      loadingEl,

      transitionEl
    ])
  },

  data: () => ({
    isOnline: true,

    layout: null,
    layoutName: '',

    nbFetching: 0
    }),

  beforeCreate () {
    Vue.util.defineReactive(this, 'nuxt', this.$options.nuxt)
  },
  created () {
    // Add this.$nuxt in child instances
    this.$root.$options.$nuxt = this

    if (process.client) {
      // add to window so we can listen when ready
      window.$nuxt = this

      this.refreshOnlineStatus()
      // Setup the listeners
      window.addEventListener('online', this.refreshOnlineStatus)
      window.addEventListener('offline', this.refreshOnlineStatus)
    }
    // Add $nuxt.error()
    this.error = this.nuxt.error
    // Add $nuxt.context
    this.context = this.$options.context
  },

  async mounted () {
    this.$loading = this.$refs.loading
  },

  watch: {
    'nuxt.err': 'errorChanged'
  },

  computed: {
    isOffline () {
      return !this.isOnline
    },

    isFetching () {
      return this.nbFetching > 0
    },
  },

  methods: {
    refreshOnlineStatus () {
      if (process.client) {
        if (typeof window.navigator.onLine === 'undefined') {
          // If the browser doesn't support connection status reports
          // assume that we are online because most apps' only react
          // when they now that the connection has been interrupted
          this.isOnline = true
        } else {
          this.isOnline = window.navigator.onLine
        }
      }
    },

    async refresh () {
      const pages = getMatchedComponentsInstances(this.$route)

      if (!pages.length) {
        return
      }
      this.$loading.start()

      const promises = pages.map(async (page) => {
        let p = []

        // Old fetch
        if (page.$options.fetch && page.$options.fetch.length) {
          p.push(promisify(page.$options.fetch, this.context))
        }

        if (page.$options.asyncData) {
          p.push(
            promisify(page.$options.asyncData, this.context)
              .then((newData) => {
                for (const key in newData) {
                  Vue.set(page.$data, key, newData[key])
                }
              })
          )
        }

        // Wait for asyncData & old fetch to finish
        await Promise.all(p)
        // Cleanup refs
        p = []

        if (page.$fetch) {
          p.push(page.$fetch())
        }
        // Get all component instance to call $fetch
        for (const component of getChildrenComponentInstancesUsingFetch(page.$vnode.componentInstance)) {
          p.push(component.$fetch())
        }

        return Promise.all(p)
      })
      try {
        await Promise.all(promises)
      } catch (error) {
        this.$loading.fail(error)
        globalHandleError(error)
        this.error(error)
      }
      this.$loading.finish()
    },
    async errorChanged () {
      if (this.nuxt.err) {
        if (this.$loading) {
          if (this.$loading.fail) {
            this.$loading.fail(this.nuxt.err)
          }
          if (this.$loading.finish) {
            this.$loading.finish()
          }
        }

        let errorLayout = (NuxtError.options || NuxtError).layout;

        if (typeof errorLayout === 'function') {
          errorLayout = errorLayout(this.context)
        }

        await this.loadLayout(errorLayout)

        this.setLayout(errorLayout)
      }
    },

    setLayout (layout) {
      if (!layout || !resolvedLayouts['_' + layout]) {
        layout = 'default'
      }
      this.layoutName = layout
      let _layout = '_' + layout
      this.layout = resolvedLayouts[_layout]
      return this.layout
    },
    loadLayout (layout) {
      const undef = !layout
      const nonexistent = !(layouts['_' + layout] || resolvedLayouts['_' + layout])
      let _layout = '_' + ((undef || nonexistent) ? 'default' : layout)
      if (resolvedLayouts[_layout]) {
        return Promise.resolve(resolvedLayouts[_layout])
      }
      return layouts[_layout]()
        .then((Component) => {
          resolvedLayouts[_layout] = Component
          delete layouts[_layout]
          return resolvedLayouts[_layout]
        })
        .catch((e) => {
          if (this.$nuxt) {
            return this.$nuxt.error({ statusCode: 500, message: e.message })
          }
        })
    },
  },

  components: {
    NuxtLoading
  }
}
